import React, {
    useState,
    useContext,
    useEffect,
} from 'react';
import {
    AsgFwContext,
    AsgDictionaryContext,
} from '../../contexts';
import { ResultsContainer } from '../ResultsContainer/ResultsContainer';
import './GameSearchWrapper.css';

export const GameSearchWrapper = () => {
    /**
     * state parameters
     */
    const AsgFw = useContext(AsgFwContext);
    const [textSearch, setTextSearch] = useState('');
    const [gamesList, setGamesList] = useState({});
    const [gamesResult, setGamesResult] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(AsgFw.isLoggedIn());
    const [placeholder, setPlaceholder] = useState('');

    /**
     * used dictionary
     * @type {{}}
     */
    const Dictionary = useContext(AsgDictionaryContext);

    useEffect(() => {
        setPlaceholder(Dictionary.translate('gameNameOrProvider'));
        setGamesList(Games.getFixedGamesList());
        document.addEventListener('justLoggedIn', handleUserStatusChange);
        document.addEventListener('justLoggedOut', handleUserStatusChange);
        return () => {
            document.removeEventListener('justLoggedIn', handleUserStatusChange);
            document.removeEventListener('justLoggedOut', handleUserStatusChange);
        };
    }, []);

    const handleUserStatusChange = () => {
        setGamesList(Games.getFixedGamesList());
        setIsLoggedIn(AsgFw.isLoggedIn());
    };

    const handleOnSearchGameChange = (e) => {
        let temp = AsgApp.stripHtml(e.target.value);
        setTextSearch(temp);
        setGamesResult([]);
        getResult(temp.toLowerCase());
    };

    const clearResult = (e) => {
        e.preventDefault();
        setTextSearch('');
        setGamesResult([]);
    };

    const handleSearchOpenStatus = (data) => {
        if (data) {
            const GAEventName = 'Search - ' + (AsgFW.isMobilePamPlatform() ? 'mobile' : 'desktop') + ' main search';
            AsgApp.GAeventTracking(GAEventName, textSearch, data.name);
        }
        setTextSearch('');
        setGamesResult([]);
    };

    const getResult = (inputFromUser) => {
        if (!inputFromUser.length) {
            setGamesResult([]);
            return;
        }
        setShowLoader(true);
        let result = [];
        let nameResult = Games.filterGamesByName(inputFromUser, gamesList);
        let providerResult = Games.filterGamesByProvider(inputFromUser, gamesList);
        let subProviderResult = Games.filterGamesBySubProvider(inputFromUser, gamesList);

        result.push(...nameResult, ...subProviderResult, ...providerResult);

        setGamesResult(filterDuplicated(result));
        setShowLoader(false);
    };

    const filterDuplicated = (result) => {
        return result.filter((value, index) => (
            index === result.findIndex(obj => obj.id === value.id)
        ));
    };

    return (
        <div className="search-game-v2__wrapper">
            <div className="search-game-v2__input">
                <div className="search-icon" />
                {
                    gamesResult && textSearch.length > 0
                &&
                (
                    showLoader ? <div className="clear-search-loader" /> :
                        <div onClick={clearResult} className="clear-search" />
                )
                }
                <input
                    autoFocus
                    value={textSearch}
                    onChange={handleOnSearchGameChange}
                    type="text"
                    placeholder= {placeholder}
                    className="search-game__input"/>
            </div>
            <div className='search-game-v2__divider'></div>
            <ResultsContainer
                gamesResult={gamesResult}
                textSearch={textSearch}
                handleSearchOpenStatus={handleSearchOpenStatus}
                isLoggedIn={isLoggedIn}
            />
        </div>
    );
};
